/**
 * 仕入の小さな部品（#233 3a、docs/93 §15.10）：状態のチップ（下書き／未払い／期限超過 MM/DD／支払済／取消）と支払期日の文字。
 * 色だけで伝えない（期限超過は朱の文字・60日超はチップの文字）
 */
import { PURCHASE_MSG, PURCHASE_STATE_LABEL, overdueText, type PurchasePayState } from "@genbaryoku/contract";
import { mdSlash } from "../../lib/num.js";

export function PurchaseStateChip({ s, dueOn, overdueDays, testId = "purchase-state" }: { s: PurchasePayState; dueOn?: string | null; overdueDays?: number; testId?: string }) {
  if (s === "overdue")
    return (
      <span className="chip shu" data-testid={testId} data-state={s} title={overdueDays ? overdueText(overdueDays) : undefined}>
        {PURCHASE_STATE_LABEL.overdue}
        {dueOn ? ` ${mdSlash(dueOn)}` : ""}
      </span>
    );
  return (
    <span className={"chip" + (s === "paid" ? " ai" : s === "draft" || s === "voided" ? " quiet" : "")} data-testid={testId} data-state={s}>
      {PURCHASE_STATE_LABEL[s]}
    </span>
  );
}

/** 支払期日の欄（一覧・{project}のタブ）：期限超過は朱の「10/24 期限超過 2日」、60日超はチップ */
export function DueCell({ dueOn, overdueDays, over60 }: { dueOn: string | null; overdueDays: number; over60?: boolean }) {
  if (!dueOn) return <span className="muted">—</span>;
  return (
    <span className="pul-due">
      <span className={"num" + (overdueDays > 0 ? " shu" : "")}>{mdSlash(dueOn)}</span>
      {overdueDays > 0 ? <b className="shu pul-over">{overdueText(overdueDays)}</b> : null}
      {over60 ? <span className="pill shu pul-60" title={PURCHASE_MSG.helpDue}>60日超</span> : null}
    </span>
  );
}
